export const dateIsBefore = (date: Date, dateToCompare: Date) =>
  date.getTime() < dateToCompare.getTime();

export const formatDate = ({
  date,
  fullMonth
}: {
  date: Date;
  fullMonth: boolean;
}): string => {
  const dateStr = new Intl.DateTimeFormat('en', {
    month: fullMonth ? 'long' : 'short',
    day: '2-digit',
    year: 'numeric'
  }).format(date);
  return dateStr;
};
